import type { AssistantSessionApi } from '../../hooks/useAssistantSession';

import { AssistantComposer } from './AssistantComposer';
import { AssistantMessageList } from './AssistantMessageList';

interface Props {
  session: AssistantSessionApi;
}

export function AssistantPanel({ session }: Props) {
  const disabled = session.status !== 'ready';
  return (
    <>
      <AssistantMessageList messages={session.messages} error={session.error} />
      <AssistantComposer disabled={disabled} onSend={session.ask} />
    </>
  );
}
